import {
  GET_RAFFLE_SLOTS,
  GET_RAFFLE_SLOTS_SUCCESS,
  GET_RAFFLE_SLOTS_ERROR,
} from "store/actions/index";

const init = {
  error: false,
};

const raffleReducer = (state: any = init, action: any): any => {
  switch (action.type) {
    case GET_RAFFLE_SLOTS:
      return {
        ...state,
        error: false,
      };
    case GET_RAFFLE_SLOTS_SUCCESS:
      return {
        ...state,
        raffleResponse: action.payload[1].response,
        error: false,
      };
    case GET_RAFFLE_SLOTS_ERROR:
      return {
        ...state,
        error: true,
      };
    default:
      return state;
  }
};

export default raffleReducer;
